import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as firebase from 'firebase/app';
import Comment from '../interfaces/Comment';
import Discussion from '../interfaces/Discussion';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss'],
})
export class ModulesComponent implements OnInit {
  // Color reference data
  colors1 = [
    { label: 'type-dark', hex: '#494949' },
    { label: 'type-neutral', hex: '#6E8099' },
    { label: 'type-light', hex: '#FAFAFA' },
    { label: 'system-error', hex: '#F17468' },
    { label: 'system-warning', hex: '#FCE48E' },
    { label: 'system-info', hex: '#94D69A' },
    { label: 'off-white', hex: '#FAFAFA' },
    { label: 'neutral-brighter', hex: '#F3F3F3' },
    { label: 'neutral', hex: '#E6E6E6' },
    { label: 'blue-light', hex: '#CBDDED' },
    { label: 'blue-darker', hex: '#195B61' },
  ];
  colors2 = [
    { label: 'blue-dark', hex: '#2673CD' },
    { label: 'blue-light', hex: '#CBDDED' },
    { label: 'blue-lighter', hex: '#DAECFF' },
    { label: 'cta', hex: '#2673CD' },
    { label: 'approach-dark', hex: '#33694C' },
    { label: 'approach-light', hex: '#E3EDE7' },
    { label: 'approach-dark', hex: '#33694C' },
    { label: 'approach-light', hex: '#E3EDE7' },
    { label: 'tag-dark', hex: '#494949' },
    { label: 'tag-light', hex: '#DCDCDC' },
  ];

  // All icon names for icon reference
  icons = [
    'copylink',
    'user',
    'visible',
    'search',
    'search-a',
    'close',
    'like',
    'like-a',
    'notification',
    'settings',
    'edit',
    'flagged',
    'flagged-a',
    'options',
    'comment',
    'comment-a',
    'filter',
    'sort',
    'adjust',
    'dropdown',
    'arrow-up',
    'arrow-left',
    'bold',
    'italics',
    'bullets',
    'numbers',
    'strikethrough',
    'quote',
    'underline',
    'text-case',
    'attachment',
    'image',
    'video',
    'pdf',
    'undo',
    'info',
    'mail',
    'mail-a',
    'comment-r',
    'file',
    'add',
    'dropdown-a',
    'globe',
    'phone',
    'star',
    'heart',
    'heart-a',
    'twitter',
    'facebook',
    'linkedin',
    'email',
    'redo',
    'text-file',
    'profile',
    'fertilization',
    'upwelling',
    'blue-carbon',
    'macroalgal',
    'alkalinity',
    'downwelling',
    'co2-removal',
    'storage',
    'other',
    'circle',
  ];

  // Dummy input data
  inputs = [
    { isFocused: false, inputValue: null },
    { isFocused: false, inputValue: null },
    { isFocused: false, inputValue: null },
    { isFocused: false, inputValue: null },
    { isFocused: false, inputValue: null },
    { toggled: false, value: null },
  ];

  // Dropdown menus
  dropdownMenus = [
    {
      toggled: false,
      listItems: [
        'Harvard Marine Laboratory',
        'La Marine Labs',
        'Marine Science NC',
        'Lorem Ipsum',
        'Lorem Ipsum',
        'Lorem Ipsum',
      ],
    },
    {
      toggled: false,
      listItems: [
        'Harvard Marine Laboratory',
        'La Marine Labs',
        'Marine Science NC',
        'Lorem Ipsum',
        'Lorem Ipsum',
        'Lorem Ipsum',
      ],
    },
    {
      toggled: false,
      listItems: [
        'Harvard Marine Laboratory',
        'La Marine Labs',
        'Marine Science NC',
        'Lorem Ipsum',
        'Lorem Ipsum',
        'Lorem Ipsum',
      ],
    },
    {
      toggled: false,
      listItems: ['Job Board', 'Events', 'Members', 'Projects', 'Institutions'],
    },
    {
      toggled: false,
      listItems: [
        { name: 'CEA Consulting', members: 14 },
        { name: 'Higher Consulting Labs', members: 8 },
        { name: 'Marine Consulting', members: 8 },
        { name: 'Organization Name', members: 32 },
        { name: 'Organization Name', members: 19 },
        { name: 'Organization Name', members: 4 },
      ],
    },
    {
      toggled: false,
      listItems: [
        { name: 'David Hauser' },
        { name: 'David Herzog' },
        { name: 'Daniela Reinhart' },
        { name: 'Danny Gross' },
        { name: 'FirstN Last N' },
      ],
    },
    {
      toggled: false,
      listItems: ['Edit', 'Another Option'],
    },
  ];

  testReply: Comment = {
    attachment: null,
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vel purus ut nisi ultrices aliquet. Fusce efficitur ex at quam lobortis, vel convallis mauris lobortis..',
    discussion: 'abc',
    id: 'abc',
    owner: 'abc',
    ownerMeta: {
      name: 'Sarah Smith',
      organization: null,
    },
    reactions: [],
    replies: [],
    newReply: 'abc',
    replyTo: 'abc',
    timestamp: new firebase.firestore.Timestamp(1591903241, 92000000),
  };

  testTopic: Discussion = {
    attachment: null,
    approaches: ['blue-carbon'],
    comments: [],
    content:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vel purus ut nisi ultrices aliquet. Fusce efficitur ex at quam lobortis, vel convallis mauris lobortis...',
    id: 'abc',
    owner: 'abc',
    ownerMeta: {
      name: 'Sarah Smith',
      organization: null,
    },
    prompt: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?',
    reactions: [],
    tags: ['markets-finance'],
    timestamp: new firebase.firestore.Timestamp(1591903241, 92000000),
    resource: null,
  };

  testUser = {
    bio: '',
    discussionStats: 12,
    displayName: 'Sarah Smith',
    documentStats: 2,
    email: 'string',
    uid: 'abc',
  };

  standardTags = [
    'technology',
    'environmental-impacts',
    'governance',
    'markets-finance',
    'funding',
    'cdr-community',
    'social-licensing',
  ];
  approachTags = [
    'fertilization',
    'upwelling',
    'blue-carbon',
    'macroalgal',
    'other-bio',
    'alkalinity',
    'downwelling',
    'co2-removal',
    'storage',
    'other-abio',
  ];

  // Notifications
  notifications = [{ hidden: false }, { hidden: false }, { hidden: true }];

  // Used for focusing on search element
  @ViewChild('search1', { static: false }) search1: ElementRef;
  @ViewChild('search2', { static: false }) search2: ElementRef;

  constructor(private toastService: ToastService) {}

  ngOnInit() {}

  focusInput(search) {
    this[search].nativeElement.focus();
  }

  toggleDropdown(target) {
    target.toggled = !target.toggled;
  }

  activateFilterDropdown(target) {
    target.value = target.value ? null : 'Sample dropdown item';
    this.toggleDropdown(target);
  }

  toggleNotification(i, toast = false) {
    // this.notifications[i].hidden = !this.notifications[i].hidden;

    // if (toast) {
    //   setTimeout(() => this.toggleNotification(i), 3000);
    // }
    this.toastService.setToast('<h1>hey</h1>');
  }
}
